const j = jQuery.noConflict();

class WishlistHeaderScript {
    constructor(DOM) {
        this.trigger = DOM.sel;
        this.Nav = DOM.Nav;
        this.page = DOM.page;
        this.header = DOM.header;
    }
    navScripts() {
        if (!j('#landing-banner').is(':visible') || j('#landing-banner').is(':visible') && j('.main-header').hasClass('sticky')){
            const navW = this.Nav.outerWidth();
            if (!this.trigger.hasClass('open')) {
                if (!j('.cart-trigger').hasClass('open')) {
                    this.trigger.addClass('open');
                    this.page.css('transform', `translate(-${navW}px, 0)`);
                    this.header.css('transform', `translate(-${navW}px, 0)`);
                    //j('body').addClass('lock-scroll');
                    j('.cart-dropdown').addClass('inactive');
                    j('.wishlist-wrapper').removeClass('inactive');
                    const myScroll = new IScroll('.wishlist-product-grid', {
                        mouseWheel: true,
                        scrollbars: false,
                    });
                    setTimeout(function(){ myScroll.refresh(); }, 100);
                } else {
                    j('.cart-trigger').removeClass('open');
                    this.trigger.addClass('open');
                    j('.cart-dropdown').addClass('inactive');
                    j('.wishlist-wrapper').removeClass('inactive');
                }
            } else {
                this.trigger.removeClass('open');
                this.page.css('transform', '');
                this.header.css('transform', '');
                j('body').removeClass('lock-scroll');
            }
        }
    }
    bindEvents() {
        this.trigger.on('click', () => this.navScripts());
    }
    closeNav() {
        if (this.trigger.hasClass('open')) {
            this.trigger.removeClass('open');
            this.page.css('transform', '');
            this.header.css('transform', '');
        }
    }
    init() {
        this.bindEvents();
    }
    loaded() {
        if(j('.wishlist-product-grid').length){
            const myScroll = new IScroll('.wishlist-product-grid', {
                mouseWheel: true,
                scrollbars: false,
            });
        }
    }
}
const DOM = {
    sel: j('.wishlist-trigger'),
    Nav: j('.side-nav.side-right'),
    page: j('#page'),
    header: j('.main-header'),
};
const WishlistHeader = new WishlistHeaderScript(DOM);

export default WishlistHeader;
